'use strict';

class Configuration {
    static get() {
        return {
            'singleGlazed': {
                'trackComponents': [
                    'singleGlazedHeadTrack',
                    'singleGlazedHeadTrackGasket',
                    'singleGlazedBaseTrack',
                    'singleGlazedCoverPlates',
                ],
                'abutmentComponents': [
                    'singleGlazedStandardWallAbutment',
                    'singleGlazedWallAbutmentGasket',
                ],
                'doors': [
                    'noDoor',
                    'singleGlazedDoorFrameless',
                    'singleGlazedDoorIncFrame',
                ]
            },
            'doubleGlazed': {
                'trackComponents': [
                    'doubleGlazedHeadTrack',
                    'doubleGlazedHeadTrackGasket',
                    'doubleGlazedBaseTrack',
                    'doubleGlazedCoverPlates',
                ],
                'abutmentComponents': [
                    'doubleGlazedStandardWallAbutment',
                    'doubleGlazedStandardWallAbutmentGasket',
                ],
                'doors': [
                    'noDoor',
                    'singleGlazedDoorIncDoubleGlazedFrame',
                    'doubleGlazedDoor',
                ],
            },
        };
    }
}

export { Configuration }



// WEBPACK FOOTER //
// ./src/objects/Configuration.js